import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: 'app.login.loginForm.title',
        defaultMessage: 'Login'
    },
    email: {
        id: 'app.login.loginForm.email',
        defaultMessage: 'Email'
    },
    password: {
        id: 'app.login.loginForm.password',
        defaultMessage: 'Password'
    },
    login: {
        id: 'app.login.loginForm.login',
        defaultMessage: 'Login'
    },
    recover: {
        id: 'app.login.loginForm.recover',
        defaultMessage: 'Forgot password?'
    },
    missingRequiredFields: {
        id: 'app.login.loginForm.missingRequiredFields',
        defaultMessage: 'Please enter email and password'
    },
    success: {
        id: 'app.login.loginForm.success',
        defaultMessage: 'Successfully logged in, you will be redirected soon.'
    },
    USER_ALREADY_ACTIVATED: {
        id: 'app.login.loginForm.USER_ALREADY_ACTIVATED',
        defaultMessage: 'You have already completed the signup, please log in to proceed.'
    }
});

export const errorMessages = defineMessages({
    UNKNOWN: {
        id: 'app.login.loginForm.UNKNOWN',
        defaultMessage: 'Something went wrong.'
    },
    INVALID_PASSWORD: {
        id: 'app.login.loginForm.INVALID_PASSWORD',
        defaultMessage: 'Wrong password.'
    },
    NO_PASSWORD: {
        id: 'app.login.loginForm.NO_PASSWORD',
        defaultMessage: 'Please enter a password.'
    },
    NO_SUCH_USER: {
        id: 'app.login.loginForm.NO_SUCH_USER',
        defaultMessage: 'Invalid email address.'
    }
});
